export interface Grade {
  id: string;
  key: string;
  description: string;
  level: number;
  obsolete: boolean;
  obsoleteString: string;
  colour: string;
}
